import axios, { type AxiosError } from "axios";
import type { BlogListApiResponse, BlogPost, BlogSingleApiResponse } from "@/types/blog";
import type { ContactFormData, LeadResponse } from "@/types/contact";

const normalizeBaseUrl = (url: string) => url.replace(/\/$/, "");
const baseURL = normalizeBaseUrl(
  process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || "http://localhost:5000/api"
);

export const api = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function getBlogs(
  limit?: number,
  page?: number,
  category?: string
): Promise<BlogListApiResponse> {
  const { data } = await api.get<BlogListApiResponse>("/blogs", {
    params: {
      ...(limit != null && { limit }),
      ...(page != null && { page }),
      ...(category && { category }),
    },
  });
  return data;
}

export async function getBlogBySlug(slug: string): Promise<BlogPost> {
  const { data } = await api.get<BlogSingleApiResponse>(`/blogs/${encodeURIComponent(slug)}`);
  return data.data;
}

export async function submitLead(data: ContactFormData): Promise<LeadResponse> {
  try {
    const { data: res } = await api.post<LeadResponse>("/leads", data);
    return res;
  } catch (err) {
    const ax = err as AxiosError<{ message?: string }>;
    throw new Error(
      ax.response?.data?.message ?? ax.message ?? "Failed to submit lead"
    );
  }
}

export async function submitCareerApplication(formData: FormData): Promise<{ success: boolean; message?: string }> {
  try {
    const { data: res } = await api.post<{ success: boolean; message?: string }>("/careers", formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res;
  } catch (err) {
    const ax = err as AxiosError<{ message?: string }>;
    throw new Error(
      ax.response?.data?.message ?? ax.message ?? "Failed to submit application"
    );
  }
}
